const popFalseCeilingWorkerService = {
  title: "POP / False Ceiling Worker",
  icon: "🏠",
  shortDescription:
    "False ceiling fixes, POP patching, minor repairs, and inspection support.",
  longDescription:
    "Book POP and false ceiling support for corrections, patch repairs, fitting adjustments, and estimate visits.",
  consultationNote:
    "Area-based or redesign work should begin with inspection before pricing.",
  responsePromise:
    "Assignment depends on ceiling condition, access, and task complexity.",
  warrantyPolicy:
    "Support depends on existing surface condition and repair scope.",
  subServices: [
    {
      id: "pop-patch-repair",
      title: "POP Patch Repair",
      icon: "🧱",
      group: "Repair",
      description:
        "Repair small broken POP section, surface damage, or ceiling patch area.",
      basePrice: 699,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "false-ceiling-adjustment",
      title: "False Ceiling Adjustment",
      icon: "📐",
      group: "Correction",
      description:
        "Correct minor looseness, alignment, or fitting issue in existing false ceiling elements.",
      basePrice: 799,
      priceType: "starts_at",
      duration: "1-3 hrs",
      warranty: "3 days",
      unit: "job",
    },
    {
      id: "false-ceiling-inspection",
      title: "POP / Ceiling Inspection",
      icon: "🔍",
      group: "Inspection",
      description:
        "Inspection for patch work, redesign estimate, or area-specific false ceiling planning.",
      basePrice: 349,
      priceType: "inspection",
      duration: "30-45 mins",
      warranty: "Inspection only",
      unit: "visit",
    },
  ],
};

export default popFalseCeilingWorkerService;